import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import { SettingsControlShell } from './SettingsControlShell';

const CHEVRON_SIZE = 18;

type SuggestedSelectTriggerProps = {
  title: string;
  value: string;
  isOpen: boolean;
};

export const SuggestedSelectTrigger = ({ title, value, isOpen }: SuggestedSelectTriggerProps) => {
  return (
    <SettingsControlShell>
      <div className="flex items-center gap-1">
        <span className="text-base-5 text-m-sb">{title}</span>
        {!!value && <span className="text-base-5 text-m-r">{value}</span>}
      </div>
      <div className={`text-base-10 w-4 h-4 flex justify-center items-center ${isOpen ? 'rotate-180' : ''}`}>
        <MdOutlineKeyboardArrowDown size={CHEVRON_SIZE} />
      </div>
    </SettingsControlShell>
  );
};
